module.exports = __webpack_public_path__ + "static/media/login-qr-code-scan.3e544930.png";